import { watch, onUnmounted, shallowRef } from 'vue';

/**
 * 模态：Esc 关闭 + 打开时聚焦 dialog。
 * @param {import('vue').Ref<boolean>} isOpen
 * @param {() => void} onClose
 */
export function useModalA11y(isOpen, onClose) {
  const dialogRef = shallowRef(null);
  let removeKey = null;
  let focusTimer = 0;

  function cleanup() {
    if (removeKey) {
      removeKey();
      removeKey = null;
    }
    if (focusTimer) {
      window.clearTimeout(focusTimer);
      focusTimer = 0;
    }
  }

  watch(
    isOpen,
    (open) => {
      cleanup();
      if (!open) return;
      const onKeyDown = (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          onClose();
        }
      };
      document.addEventListener('keydown', onKeyDown);
      removeKey = () => document.removeEventListener('keydown', onKeyDown);
      focusTimer = window.setTimeout(() => {
        dialogRef.value?.focus?.();
      }, 0);
    },
    { immediate: true },
  );

  onUnmounted(cleanup);

  return dialogRef;
}
